import { TEMP_SESSION_TRANSFER } from '../constants/localStorage.constants'

/**
 * Restores session storage from localStorage in a new tab
 * This enables authentication to persist when opening help pages in new tabs
 */
export const restoreSessionFromLocalStorage = (): void => {
  try {
    // Check if sessionStorage is empty but localStorage has a temp session
    const hasExistingSession = sessionStorage.getItem('persist:root')
    const tempSession = localStorage.getItem(TEMP_SESSION_TRANSFER)

    if (!hasExistingSession && tempSession) {
      // Restore the session from localStorage to sessionStorage
      sessionStorage.setItem('persist:root', tempSession)
      
      // Clean up the temporary storage immediately
      localStorage.removeItem(TEMP_SESSION_TRANSFER)
      
      // Reload to ensure Redux store rehydrates with the restored session
      window.location.reload()
    }
  } catch (error) {
    console.error('Error restoring session from localStorage:', error)
    // Clean up on error
    try {
      localStorage.removeItem(TEMP_SESSION_TRANSFER)
    } catch (cleanupError) {
      console.error('Error cleaning up temp session:', cleanupError)
    }
  }
}
